module.exports = __webpack_public_path__ + "static/devices-a9fc51b22715a0b01a734d1f57d6e09b.jpg";